import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
import { useEffect, useState } from "react";
import { isNotUndefinedOrNull, postForm } from "../FunctionsCore";
import { renderIdentifierGeneric } from "../RenderIdentifier";
import ThemeProvider from "../theme";
import { ProductDetailsHeroComponent } from "./ProductDetailsHero";
import { ProductFamilyHeroComponent } from "./ProductFamilyHero";
const WrapperStyle = styled("div")(({ theme }) => ({
    "backgroundColor": theme.palette.common.white,
}));
const ProductHeroComponent = (props) => {
    const { cartCheckoutActionUrl, cta, heroType, magentoCartServletPath } = props;
    const [productFamilyHeroButtonText, setProductFamilyHeroButtonText] = useState();
    useEffect(() => {
        var _a, _b, _c;
        switch (cta === null || cta === void 0 ? void 0 : cta.type) {
            case "link": {
                setProductFamilyHeroButtonText((_a = cta.link) === null || _a === void 0 ? void 0 : _a.label);
                break;
            }
            case "cart": {
                setProductFamilyHeroButtonText((_b = cta.cart) === null || _b === void 0 ? void 0 : _b.label);
                break;
            }
            case "magentoCart": {
                setProductFamilyHeroButtonText((_c = cta.magentoCart) === null || _c === void 0 ? void 0 : _c.label);
                break;
            }
            default: {
                break;
            }
        }
    }, [cta]);
    const actionItemHandler = () => {
        var _a, _b;
        if (isNotUndefinedOrNull(cta)) {
            switch (cta.type) {
                case "link": {
                    window.location.href = (_b = (_a = cta.link) === null || _a === void 0 ? void 0 : _a.hrefUrl) !== null && _b !== void 0 ? _b : "";
                    break;
                }
                case "cart": {
                    if (isNotUndefinedOrNull(cta.cart) && isNotUndefinedOrNull(cartCheckoutActionUrl)) {
                        const legacyCartProperties = Object.assign({}, cta.cart);
                        postForm(cartCheckoutActionUrl, legacyCartProperties, "post");
                    }
                    break;
                }
                case "magentoCart": {
                    if (isNotUndefinedOrNull(cta.magentoCart) && isNotUndefinedOrNull(magentoCartServletPath)) {
                        const magentoCartProperties = Object.assign({}, cta.magentoCart);
                        postForm(magentoCartServletPath, magentoCartProperties, "get");
                    }
                    break;
                }
                default: {
                    break;
                }
            }
        }
    };
    return (_jsx(ThemeProvider, { children: _jsx(WrapperStyle, { children: heroType === "familyHero" ? (_jsx(ProductFamilyHeroComponent, Object.assign({}, props, { actionItemHandler: actionItemHandler, productFamilyHeroButtonText: productFamilyHeroButtonText }))) : (_jsx(ProductDetailsHeroComponent, Object.assign({}, props, { actionItemHandler: actionItemHandler, productFamilyHeroButtonText: productFamilyHeroButtonText }))) }) }));
};
const productHero = (renderableData) => renderIdentifierGeneric(ProductHeroComponent, renderableData);
export { productHero };
